"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWallet = exports.WalletProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var useConnectWallet_1 = __importDefault(require("../hooks/useConnectWallet"));
var ConnectWalletContext = (0, react_1.createContext)({
    address: "",
    cookie: "",
    client: undefined,
    wallet: undefined,
    login: function () {
        return false;
    },
    logout: function () {
        return false;
    }
});
function WalletProvider(_a) {
    var children = _a.children;
    var _b = (0, useConnectWallet_1.default)(), address = _b.address, cookie = _b.cookie, client = _b.client, login = _b.login, logout = _b.logout, wallet = _b.wallet;
    return ((0, jsx_runtime_1.jsx)(ConnectWalletContext.Provider, __assign({ value: { address: address, cookie: cookie, client: client, login: login, logout: logout, wallet: wallet } }, { children: children })));
}
exports.WalletProvider = WalletProvider;
function useWallet() {
    return react_1.default.useContext(ConnectWalletContext);
}
exports.useWallet = useWallet;
